import React, { useEffect, useState } from 'react';
import Header from '../../components/common/global-top-bar';
import { Link } from 'react-router-dom';
import { useDispatch, connect } from 'react-redux';
import Spinner from '../../components/common/spinner';
import { ROUTE_PATH } from '../../routes/paths';
import { fetchUserListRequest, postBlackListRequest, updateUserRequest } from './redux-tags/actions';
import { CustomInput, ToggleButton } from '../../components/common';
import {
  defaultModal,
  emailMapping,
  Headeroptions,
  userManagementFilter,
  userStatusOptions,
  UserTypes,
} from './user-safety-constants';
import SwitchBar from '../../components/switch-bar';
import Modal from '../../components/common/modal';
import { convertObjectToParams } from '../../components/common/create-params';
import { useSettings } from '../../hooks/useSettings';

type props = {
  tagsList: any;
  pending: any;
  TagsCount: any;
  appSettings: any;
};

type FilterProps = {
  addFunctionality: () => void;
  fetchData: (data: any) => void;
  count: number | undefined;
};

export type CardProps = {
  photo: any;
  displayName: string;
  firstName: string;
  lastname: string;
  peerType: string;
  userEvents: any;
  email: string;
  phoneNumber: string;
  userId: number;
  filterType: string;
  appSettings: any;
  listenerDetails: any;
  callerDetails: any;
};

const Filters: React.FunctionComponent<FilterProps> = ({ count, fetchData }): JSX.Element => {
  const [filters, setfilters] = useState({
    page: 1,
    limit: 25,
    search: '',
    status: UserTypes['Under Review'],
    include_ratings: true,
    include_topics: true,
    include_call_summary: true,
    include_user_safety: true,
    include_requests: true,
  });

  return (
    <div className="gray-border-line bg-gray-background-light flex h-10 w-full items-center justify-between border-b px-7">
      <div className="w-1/3"></div>
      <div className="w-1/4"></div>
      <div className="w-2/3">
        <div className="flex justify-end">
          <div className="gray-background-dark flex items-center justify-between py-4">
            {Object.keys(UserTypes).map((item) => (
              <button
                className={
                  'px-5 py-1 text-sm ' +
                  //@ts-ignore
                  (UserTypes[item] === filters.status
                    ? 'bg-blue-primary text-white'
                    : 'bg-gray-background-dark text-gray-dark')
                }
                onClick={() => {
                  //@ts-ignore
                  setfilters((filter) => {
                    //@ts-ignore
                    return { ...filter, status: UserTypes[item], page: 1 };
                  });
                  //@ts-ignore
                  fetchData({ ...filters, status: UserTypes[item], page: 1 });
                }}
              >
                {/* @ts-ignore */}
                {item}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const Card: React.FunctionComponent<CardProps> = ({
  photo,
  firstName,
  lastname,
  peerType,
  userEvents,
  email,
  phoneNumber,
  userId,
  filterType,
  appSettings,
  listenerDetails,
  callerDetails,
}): JSX.Element => {
  const dispatch = useDispatch();
  const [modal, setModalState] = useState<any>(defaultModal);

  const handleBlackList = (type: string) => {
    dispatch(
      postBlackListRequest({
        payload: {
          entity_type: type,
          value: type === 'email_address' ? email : phoneNumber,
        },
        filters: { ...userManagementFilter, status: filterType },
        from: 'users',
      }),
    );
  };

  const handleStatus = (status: 'banned' | 'enabled' | 'suspended' | 'under_review') => {
    setModalState({
      email: appSettings[emailMapping[status].body],
      subject: appSettings[emailMapping[status].subject],
      toggle: true,
      status: status,
      enable: true,
    });
  };

  const handleSave = () => {
    dispatch(
      updateUserRequest({
        id: userId,
        payload: {
          status: modal.status,
          message: modal.toggle ? modal.email : undefined,
          subject: modal.toggle ? modal.subject : undefined,
        },
        filterType,
      }),
    );
    setModalState(defaultModal);
  };

  const handlePopUp = (key: string, value: boolean | string) => {
    setModalState((prev: any) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <>
      <Modal
        isModel={modal.enable}
        InnerComponent={
          <div className="inline-block transform overflow-hidden rounded-lg bg-white text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:align-middle">
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              <div className="sm:flex sm:items-start">
                <div className="mt-3 w-full text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <div className="my-2 w-full">
                    <CustomInput
                      inputType={'text'}
                      value={modal?.subject}
                      setValue={(data: string) => {
                        handlePopUp('subject', data);
                      }}
                      Label={'Subject'}
                      labelClass={'block text-sm leading-4   text-blue-dark mb-2'}
                      dataTestId="user-management-subject"
                    />
                  </div>

                  <h3 className="text-blue-dark mb-2 block text-sm leading-4" id="modal-title">
                    Body
                  </h3>

                  <div className="my-2 w-full">
                    <textarea
                      className="text-gray-dark bg-gray-background-light h-28 w-full rounded-md px-3 py-2 text-sm font-extrabold leading-4 focus:outline-none"
                      value={modal.email}
                      onChange={(evt) => {
                        handlePopUp('email', evt.target.value);
                      }}
                      dataTestId="user-management-body"
                    />
                  </div>

                  <div className="w-1/2">
                    <div className="flex items-center justify-between">
                      <label className="text-blue-dark mb-2 block text-sm leading-4"> Send Message </label>

                      <ToggleButton
                        id={'Send Message'}
                        status={modal?.toggle}
                        setStatus={(data) => {
                          handlePopUp('toggle', data);
                        }}
                        initialstatus={true}
                        data-testid="user-management-send-message-toggle"
                      ></ToggleButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button
                type="button"
                onClick={handleSave}
                className="stacked-bar-blue-400 inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
                data-testid="user-management-save-button"
              >
                SAVE
              </button>

              <button
                type="button"
                onClick={() => {
                  handlePopUp('enable', false);
                }}
                className="stacked-bar-blue-400 inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
                data-testid="user-management-close-button"
              >
                CLOSE
              </button>
            </div>
          </div>
        }
      />
      <div className="border-blue-primary my-3 h-auto rounded-sm border-b-2 px-3 py-3">
        <div className={'flex h-48 w-full rounded bg-white'}>
          {photo && (
            <div className="flex items-center justify-center px-2">
              <div
                className={`h-28 w-28 rotate-45 transform rounded-full border-4 bg-gray-100 ${
                  peerType === 'peer'
                    ? `border-gray-dark`
                    : peerType === 'upgrade'
                      ? `upgrade-border`
                      : `border-blue-primary`
                }`}
              >
                <img className="h-full w-full -rotate-45 transform" src={photo} alt="listenerProfile" />
                <div></div>
              </div>
            </div>
          )}

          <div className="w-full py-4 pl-4">
            <p className="blue-primary py-1 pt-5 text-2xl font-normal">{`${firstName} ${lastname}`}</p>
            <p className="text-gray-dark py-1 text-xl font-normal">{`${email}`}</p>
            <p className="text-gray-dark mb-1 py-1 text-xl font-normal">{`${phoneNumber}`}</p>
            <div className="flex space-x-3">
              {' '}
              {listenerDetails && (
                <Link
                  className="bg-blue-primary mx-2 mt-2 cursor-pointer rounded-md p-2 font-bold text-white"
                  to={`${ROUTE_PATH.LISTENERS_PROFILE}${convertObjectToParams(listenerDetails)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Listener Profile
                </Link>
              )}
              {callerDetails && (
                <Link
                  className="bg-blue-primary mx-2 mt-2 cursor-pointer rounded-md p-2 font-bold text-white"
                  to={`${ROUTE_PATH.MEMBERS_PROFILE}${convertObjectToParams(callerDetails)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Caller Profile
                </Link>
              )}
            </div>
          </div>
          <div className="mt-4 h-44 w-full border-2 border-gray-300 px-3">
            <p className="blue-primary py-1 text-xl font-normal">Report</p>
            <p className="text-gray-dark">{userEvents?.length > 0 ? userEvents[0].message : ''}</p>
            <p className="text-gray-dark pt-4">
              This user has been reported {userEvents?.length > 0 ? userEvents.length : 0} time(s)
            </p>
          </div>
        </div>
        <div className="mt-3 flex space-x-3">
          <div className="h-auto w-1/2 border-2 px-3 py-3 pb-5">
            <p className="blue-primary ml-3 py-2 text-xl font-normal">Black List</p>
            <button
              className="bg-blue-primary mx-2 rounded-md p-2 font-bold text-white"
              onClick={() => {
                handleBlackList('email_address');
              }}
              data-testid="blacklist-email-address-button"
            >
              Email Address
            </button>
            <button
              className="bg-blue-primary rounded-md p-2 font-bold text-white"
              onClick={() => {
                handleBlackList('mobile_phone');
              }}
              data-testid="blacklist-phone-number-button"
            >
              Phone Number
            </button>
          </div>
          <div className="h-auto w-1/2 border-2 border-gray-300 px-3 py-3 pb-5">
            <p className="blue-primary ml-3 pt-2 text-xl font-normal">Actions</p>
            {userStatusOptions.map((option: any) => (
              <button
                className="bg-blue-primary mx-2 my-2 rounded-md p-2 font-bold text-white"
                onClick={() => {
                  handleStatus(option.action);
                }}
                data-testid={`user-management-${option.action}-button`}
              >
                {option.name}
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

const UserManagement: React.FunctionComponent<props> = (props): JSX.Element => {
  const [filterType, setfilterType] = useState(UserTypes['Under Review']);
  const { data: appSettings } = useSettings('email');

  const dispatch = useDispatch();

  const fetchData = (filter: any) => {
    const { page, limit, ...rest } = filter;
    setfilterType(filter.status);
    dispatch(fetchUserListRequest(filter));
  };

  useEffect(() => {
    dispatch(fetchUserListRequest(userManagementFilter));
  }, []);

  return (
    <div>
      <Header heading={'Safety'} />
      <SwitchBar heading={Headeroptions} position={0} />

      <Filters count={props.TagsCount?.count} fetchData={fetchData} addFunctionality={() => {}} />

      <div className="max-window-height overflow-y-auto pb-10">
        <div className="w-full px-7">
          {props.pending && <Spinner />}

          <div className={'w-full rounded bg-white px-7'}>
            {props.tagsList?.length > 0 ? (
              props.tagsList?.map((user: any) => (
                <Card
                  photo={user?.listener_role?.profile_photo_file_url}
                  displayName={''}
                  firstName={user?.first_name}
                  lastname={user?.last_name}
                  peerType={user?.listener_role?.can_take_calls}
                  userEvents={user?.user_events}
                  phoneNumber={user?.mobile_phone}
                  email={user?.email_address}
                  userId={user?.id}
                  filterType={filterType}
                  appSettings={appSettings?.message}
                  listenerDetails={
                    user?.listener_role
                      ? {
                          listenerRoleId: user.listener_role.id,
                          listenerId: user.id,
                          listenerType: user.can_take_calls ? 'listener' : 'peer',
                          listenerName: user.first_name,
                        }
                      : null
                  }
                  callerDetails={
                    user?.caller_role_id
                      ? {
                          name: user.first_name,
                          id: user.id,
                          callerRoleId: user.caller_role_id,
                        }
                      : null
                  }
                />
              ))
            ) : (
              <p className="blue-primary ml-3 py-2 text-xl font-normal">No Users Found</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    tagsList: state.safety.UserList?.data || null,
    pending: state.safety?.pending || state.Client?.pending || null,
  };
};

export default connect(mapStateToProps)(UserManagement);
